// Imports
import React from "react"
import { Routes, Route } from "react-router-dom"
import { v4 as uuid } from "uuid"

import routes from "./routes"
import routeDemos from "./routes/route-demos"

const App = () => {
    return (
        <Routes>
            {routes.map(route => (
                <Route
                    path={route.path}
                    element={<route.element />}
                    key={uuid()}
                />
            ))}

            {routeDemos.map(route => (
                <Route
                    path={route.path}
                    element={<route.element />}
                    key={uuid()}
                />
            ))}
        </Routes>
    )
}

export default App
